import * as amplitude from "@amplitude/analytics-browser";

export const fireEventBeforeNavigation = async (trackingFn: () => void) => {
  try {
    trackingFn();
    await amplitude.flush().promise;
  } catch (err) {
    console.log('Tracking failed with error :', err);
  } finally {
    amplitude.setTransport('fetch');
  }
};